
import TableList from "@components/templates/tablelist";
import { HttpGetWarehouseSkuList,HttpDeleteWarehouseSkuOne } from "@/service/products/channel";
import { mapState,mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
        }
    },
    methods: {
        ajaxRequest: HttpGetWarehouseSkuList,
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'warehouseskuUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    var url = this.$router.resolve({
                        name: 'warehouseskuUpdate',
                        params: { type: 'edit' },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title:'查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "warehouseskuUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "disable":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "删除",
                        width: 460,
                        params:{ids:params},
                        ajaxRequest:HttpDeleteWarehouseSkuOne
                    };
                    break;
                
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id,status } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show:true,
                params:id,
                operate:'edit'
            },{
                label:'删除',
                show:status == 'NORMAL',
                params:id,
                operate:'disable'
            },]
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getNewWarehouseIdList']),
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "批量删除",
                    operate: "disable",
                    more:true,
                    batch:true
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            return  [
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_erpsku',
                    show:true,
                },
                {
                    label: "仓库SKU",
                    tag: 'vInput',
                    key: 'EQ_orgWarehouseSku',
                    show:true,
                },

                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewProductList,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: "仓库名称",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    options: this.getNewWarehouseIdList,
                    props:{
                        filterable:true,
                    }
                },
                
                {
                    label: "创建人",
                    tag: 'vInput',
                    key: 'EQ_createdName',
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: "width:180px",
                },
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 90,
                render:this.getOperateNodes
            }, 
            {
                title: 'ERPSKU',
                key:'erpsku',
                sortable: true,
                render:(h,{row})=>{
                    return <div><a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.erpsku}</a>
                    </div>
                }
            },
            {
                title: '仓库SKU',
                key:'orgWarehouseSku',
                sortable: true,
            },
            
            {
                title: '仓库名称',
                render:(h, { row }) => this.findRenderLabel(this.getNewWarehouseIdList, row.orgWarehouseId),
            },
            {
                title: '项目',
                render:(h, { row }) => this.findRenderLabel(this.getNewProductList, row.lineId),
            },
            {
                title: '创建时间/更新时间',
                render:(h,{row})=>{
                    return <div>
                        <div>{row.createdAt}</div>
                        <div>{row.updatedAt}</div>
                    </div>
                }
            },
        ];
        },
        
    },

};
